// ---------------------------------------------------------------------------
// BRAND & SITE CONFIG — edit copy/links here, no component changes needed.
// ---------------------------------------------------------------------------
export const SITE_URL = "https://barverse.com";
export const TACOVERSE_URL = "https://tacoverse.com";
export const TACOVERSE_MENU_URL = "https://tacoverse.com/menu";
export const TACOVERSE_ORDER_URL = "https://tacoverse.toast.site/order";
export const CONTACT_EMAIL = "info@tacoverse.com";
export const API_BASE = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const NAV_LINKS = [
  { label: "Drinks", path: "/drinks" },
  { label: "Food", path: "/food" },
  { label: "Sports", path: "/sports" },
  { label: "Groups", path: "/groups" },
  { label: "Locations", path: "/locations" },
];

// Homepage split section lists (brief §9)
export const DRINK_LIST = [
  "Signature Cocktails",
  "Core Favorites",
  "Draft & Bottled Beer",
  "Wine",
  "Tequila",
  "Spirits",
  "Zero Proof",
];

export const FOOD_LIST = [
  "Tacos",
  "Burritos",
  "Bowls",
  "Salads",
  "Quesadillas",
  "Sides",
  "Desserts",
  "Kids",
];

export const USE_CASES = [
  "Game Days",
  "Watch Parties",
  "Birthdays",
  "After Work",
  "Team Gatherings",
  "Celebrations",
];

export const MARQUEE_ITEMS = [
  "Signature Cocktails",
  "Good Times",
  "Food by Tacoverse",
  "Two Big Screens",
  "Game On",
  "Watch Parties",
];

export const RESPONSIBLE_MESSAGE =
  "You must be 21 or older to purchase or consume alcoholic beverages. Please drink responsibly.";

// SEO keyword sets — one base set plus a topical set per page
export const BASE_KEYWORDS =
  "Barverse, sports bar, cocktail bar, Tex-Mex restaurant, Tacoverse food, tacos and cocktails near me";

export const PAGE_KEYWORDS = {
  drinks:
    "signature cocktails, margaritas, tequila bar, craft beer, draft beer, bottled beer, wine, vodka, whiskey, bourbon, rum, gin, liqueurs, cocktail menu",
  food: "Tex-Mex food, tacos, burritos, bowls, salads, quesadillas, queso, churros, food by Tacoverse, Tacoverse menu",
  sports:
    "watch sports, NFL, NBA, MLB, NHL, college football, college basketball, soccer, two big screens, watch party bar, game day",
  groups:
    "group events, watch parties, birthday party bar, after work drinks, team gatherings, celebrations, group dining",
  locations: "Barverse locations, DFW bar, Dallas Fort Worth cocktail bar, North Florida bar, opening soon",
};

export const breadcrumbSchema = (path, name) => ({
  "@context": "https://schema.org",
  "@type": "BreadcrumbList",
  itemListElement: [
    { "@type": "ListItem", position: 1, name: "Barverse", item: "https://barverse.com/" },
    { "@type": "ListItem", position: 2, name, item: `https://barverse.com${path}` },
  ],
});
